import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';

export default class SelectItemList extends Component {
  static propTypes = {
    /** @ignore */
    children: renderableType.isRequired,
    /** @ignore */
    listRef: PropTypes.func,
  };
  render() {
    const {
      children,
      listRef,
      ...other
    } = this.props;

    return (
      <div ref={n => listRef(n)} {...other}>
        {children}
      </div>
    );
  }
}
